/**
 * @fileoverview Text Content View - handles UI interactions for the post text area. Includes
 * embedded field interactions and the character counter
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.TextContentView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');
const embed = goog.require('yext.textfield.embed');

/** @constructor */
const TextContentView = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$el = this.options.$el || $('.js-post-text-container');

  /**
   * @type {embed.TextFieldEmbed}
   * @private
   */
  this.embeddedFields_ = null;

  /**
   * @type {Model}
   * @private
   */
  this.model_ = new Model().init({
    value: this.options.message || this.$el.find('.js-post-text-box').val(),
  });

  /**
   * @type {Function}
   * @private
   */
  this.onChange_ = null;
};

/** @return this */
TextContentView.prototype.init = function() {
  this.bindInputChange_();
  this.bindEmbeddedFields_();
  this.render_();
  return this;
};

/**
 * @param {Function} cb
 */
TextContentView.prototype.onChange = function(cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('TextContentView.onChange: Invalid cb, expected a function');
  }
  this.onChange_ = cb;
};

/**
 * @return {!Object<string, ?>}
 */
TextContentView.prototype.getData = function() {
  return {
    'message': this.model_.get('value'),
  };
};

/** Clears out the content of the textbox */
TextContentView.prototype.reset = function() {
  this.model_.resetState({
    'value': '',
  });
};

/**
 * Toggles the presence of the embedded fields selector
 * @param {boolean} enabled
 */
TextContentView.prototype.toggleEmbeddedFields = function(enabled) {
  // NOTE(slanden): Currently, if there are already embedded fields in a post, and then embedded
  // fields are disabled, we leave the existing fields in place. We may want to change that
  this.embeddedFields_.toggle(enabled);
};

/**
 * Sets the postbox message
 * @param {string} message
 */
TextContentView.prototype.setMessage = function(message) {
  this.model_.resetState({
    'value': message,
  });
};

/** @private */
TextContentView.prototype.bindInputChange_ = function() {
  this.$el.find('.js-post-text-box').inputchange(function(e) {
    this.model_.set('value', $(e.target).val());
  }.bind(this));

  this.model_.on('change,reset', function() {
    if (this.onChange_) {
      this.onChange_(this.getData());
    }
  }.bind(this));

  this.model_.on('reset', function() {
    this.render_();
  }.bind(this));
};

/** @private */
TextContentView.prototype.bindEmbeddedFields_ = function() {
  this.embeddedFields_ = embed.create(this.$el, {
    startWrap: '[',
    endWrap: ']', // TODO(hydra): Update social posts embedded fields to use standard [[ ]]
  });
};

/** @private */
TextContentView.prototype.render_ = function() {
  this.$el.find('.js-post-text-box').val(this.model_.get('value'));
};

exports = TextContentView;
